<template> 
    <div
      class="modal fade"
      id="margin_modal"
      tabindex="-1"
      aria-hidden="true"
      ref="setDeliveryDataModalRef"
    >
      <!--begin::Modal dialog-->
      <div class="modal-dialog modal-dialog-centered mw-650px">
        <!--begin::Modal content-->
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="kt_modal_add_customer_header">
            <!--begin::Modal title-->
            <div class="col-7 d-flex">
              <!-- <div class="row" v-if="AICode">
                <div class="col-6">
                  <h2 class="fw-bolder" >ใบรับมัดจำ  </h2> 
                </div>
                <div class="col-4">
                  <span style="font-size: 14px !important;">{{AICode}}</span>
                </div>
              </div> -->
              <h3  v-if="UORefNo">คำสั่งซื้อ #{{ UORefNo }} </h3>  &nbsp;&nbsp;   
              
             
            </div>     
            <!--end::Modal title-->

            <!--begin::Close-->
            <!-- <div
              id="kt_modal_add_customer_close"
              data-bs-dismiss="modal"
              class="btn btn-icon btn-sm btn-active-icon-primary"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div> -->
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <!--begin::Modal body-->
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
            label-width="160px"
          >
            <div class="modal-body py-2 px-lg-10">
              <!--begin::Scroll-->
              <div
                class="scroll-y me-n7 pe-7"
                id="kt_modal_add_customer_scroll"
                data-kt-scroll="true"
                data-kt-scroll-activate="{default: false, lg: true}"
                data-kt-scroll-max-height="auto"
                data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                data-kt-scroll-wrappers="#kt_modal_add_customer_scroll"
                data-kt-scroll-offset="300px"
              >
              <el-form-item label="วันที่จัดส่ง" >
                  <el-date-picker
                      v-model="ruleForm.dateStart"                      
                      type="date"
                      placeholder="วันที่"
                      format="DD/MM/YYYY"
                      value-format="YYYY-MM-DD"  
                      style="width: 150px;"
                      :disabled-date="disabledStartDate"                      
                      @change="changeStartDate"
                  >
                  </el-date-picker>                            
                  &nbsp;&nbsp;
                  <el-time-select
                      v-model="ruleForm.timeStart"
                      start="00:00"
                      placeholder="เวลา"
                      style="width: 130px;"
                  >
                  </el-time-select>                            
                </el-form-item>
                       
                <el-form-item
                  label="ทะเบียนรถ"
                  prop="truckID"
                  style="margin-bottom: 17px"            
                  v-if="Order.delivery_method.trim() != 'pickup'"
                >
                  <div class="d-flex">
                    <div class="w-180px fw-bolder me-5">
                      <el-select
                        style="width: 100%"
                        v-model="ruleForm.truckID"
                        placeholder="ทะเบียนรถ"
                      >
                        <el-option v-for="t in truckList" :key="t.pnTruckID" :label="t.pnTruckCode" :value="t.pnTruckID"></el-option>
                      </el-select>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item
                  label="ทะเบียนรถ"
                  prop="cusTruckCode"
                  style="margin-bottom: 17px"            
                  v-else
                >
                  <div class="d-flex">
                    <div class="w-180px fw-bolder me-5">
                      <el-input
                        v-model="ruleForm.cusTruckCode"
                      >
                      </el-input>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item
                  label="หมายเหตุ"
                  prop="remark"
                  style="margin-bottom: 13px"
                >
                  <el-input
                    type="textarea"
                    placeholder=""
                    v-model="ruleForm.partnerNote"
                    maxlength="200"
                    show-word-limit
                    rows="3"
                    class="w-130px"      
                  >
                  </el-input>
                </el-form-item>
              </div>
              <!--end::Scroll-->
            </div>
            <!--end::Modal body-->
            <div class="modal-footer">
              <button
                class="btn btn-light-primary me-3"
                type="reset"
                @click="hide"
                style="width: 150px"
              >
                ปิด
              </button>
              <el-button
                style="width: 150px"
                type="primary"
                :loading="btnLoading"
             
                @click="submitForm('ruleForm')"
             
              >
                {{
                  btnLoading == true ? "กรุณารอสักครู่..." : "บันทึก"
                }}
              </el-button>
            </div>
          </el-form>
        </div>
        <!--begin::Modal content-->
      </div>
      <!--begin::Modal dialog-->
      
    </div>
</template>

<script>
import ApiService from "@/core/services/ApiService";
import { Modal } from "bootstrap";
import { numberWithCommas, formatDateFromISO, formatDateThDate ,formatTime} from "@/utils";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { DatetimeFormat } from "vue-i18n";


export default {
  props: {
    UORefNo: String,
    Order:Object
  }, 
  data() {
    return {
      truckList:[],
      ruleForm: {
        truckID:null,
        cusTruckCode:"",
        partnerNote:"",
        partnerDeliveryDate:null,
        dateStart:null,
        timeStart:null,
        timeEnd:null

      },
      rules: {
        truckID: [
          { required: this.Order.delivery_method.trim() != 'pickup', message: "กรุณากรอกทะเบียนรถ", trigger: "blur" },
        ],
        cusTruckCode: [
          { required: this.Order.delivery_method.trim() == 'pickup', message: "กรุณากรอกทะเบียนรถ", trigger: "blur" },
        ],        
        dateStart: [
          { required: true, message: "กรุณากรอกวันที่ส่ง", trigger: "blur" },
        ],
        // timeStart: [
        //   { required: true, message: "กรุณากรอกเวลาส่ง", trigger: "blur" },
        // ]
        
      },
      disabledStartDate(date) {
          var currentDate =  new Date()
          return date < currentDate.setDate(currentDate.getDate() - 1)
      },
      setDeliveryDataModalRef: null,
      btnLoading: false,
      errorText:null
    };
  },
 
  mounted() {
    // await this.getDeliveryOrder();
    console.log("mounted",this.Order);
    // this.dateStart = this.Order.partnerDeliveryDate;
    // this.timeStart = new Date(this.Order.partnerDeliveryDate).getTime();
    this.setDeliveryDataModalRef = new Modal(this.$refs.setDeliveryDataModalRef); 
  
   
   
  },
  methods: {
    numberWithCommas,
    formatDateFromISO,
    hide() {
      this.ruleForm = [];
      this.rules={};
      this.isTaxID = false;
      this.setDeliveryDataModalRef.hide();
      this.$emit("refreshdata");
      
    },
    show() {
      this.setDeliveryData();
      this.getTruckCodeList();      
      this.setDeliveryDataModalRef.show();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && !this.errorText) {
          this.SaveDeliveryData();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
    
    SaveDeliveryData: async function () {

      const loader = this.$loading.show();
      try {
        var tempData;
        this.ruleForm.partnerDeliveryDate = this.ruleForm.dateStart;
        loader.hide();
        if((this.ruleForm.truckID && this.Order.delivery_method.trim() != 'pickup') || (this.ruleForm.cusTruckCode && this.Order.delivery_method.trim() == 'pickup')){
          
          const { data } = await ApiService.post("Orders/UpdateDeliveryData", {
            truckID: this.ruleForm.truckID,
            cusTruckCode:this.ruleForm.cusTruckCode,
            partnerNote: this.ruleForm.partnerNote,
            dateStart: this.ruleForm.dateStart,
            timeStart:this.ruleForm.timeStart,
            uoRefNo:this.UORefNo
          });
          tempData = data;
          if(data.success === 0 ){
            await Swal.fire("แจ้งเตือน", data.errorText, "warning"); 
          }
          
          this.$emit("getOrderFn")
        }else{
            Swal.fire("", "กรุณาระบุทะเบียนรถ" , "warning"); 
        }
        
         
      } catch (error) {
        Swal.fire({
          text: "เกิดข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ปิด",
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          //this.hide();
        });
      }
      this.hide();
      this.btnLoading = false;
      loader.hide();

    },
    
    setDeliveryData(){
      this.ruleForm.partnerDeliveryDate = this.Order.partnerDeliveryDate;
      this.ruleForm.dateStart = this.Order.partnerDeliveryDate.split('T')[0];
      this.ruleForm.timeStart =formatTime(this.Order.partnerDeliveryDate);
      this.ruleForm.truckID =  this.Order.delivery_method.trim() != 'pickup'?this.Order.truckID:0;
      this.ruleForm.cusTruckCode = this.Order.delivery_method.trim() == 'pickup'?this.Order.cusTruckCode:"";
      this.ruleForm.partnerNote =   this.Order.partnerNote
    },
    getTruckCodeList () {
      
      let url = "orders/GetPartnerTruckCode"
      
      ApiService.query(
        url)
        .then((res) => {
          this.truckList = res.data;

          // console.log("this.truckList",this.truckList);
        })
        .catch(err => {
          console.log(err)
        })
        .finally( () => {
          this.loading = false
          // this.selectedOrder = null
        })
    },
   
    changeStartDate(){
      console.log();
    },
  },
};
</script>

<style>
.el-form-item__label {
  text-align: left;
}
.modal-footer {
  justify-content: center;
}
.el-icon-search {
  color: #fff;
}
.el-input.is-disabled .el-input__inner {
  color: #606266;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
</style>